/**
 * Artist detail page (sections/artist-page.liquid):
 *   1. "Read More" / "Hide Bio" toggle for the full bio.
 *   2. Portfolio lightbox: every <a data-lightbox="portfolio"> opens its
 *      full-size image in a <dialog>, with prev/next and close. Without
 *      <dialog> support the links just open the image normally.
 */
(function () {
  // ---- 1. Read more toggle ------------------------------------------------
  document.querySelectorAll('.pm-read-more').forEach(function (link) {
    var target = document.getElementById(link.getAttribute('aria-controls'));
    if (!target) return;

    var moreText = link.getAttribute('data-more-text') || link.textContent;
    var lessText = link.getAttribute('data-less-text') || 'Hide Bio';

    link.addEventListener('click', function (event) {
      event.preventDefault();
      var isOpen = link.getAttribute('aria-expanded') === 'true';
      link.setAttribute('aria-expanded', String(!isOpen));
      target.hidden = isOpen;
      link.textContent = isOpen ? moreText : lessText;
    });
  });

  // ---- 2. Portfolio lightbox ----------------------------------------------
  var links = Array.prototype.slice.call(
    document.querySelectorAll('a[data-lightbox="portfolio"]')
  );
  if (!links.length || typeof HTMLDialogElement === 'undefined') return;

  var dialog = document.createElement('dialog');
  dialog.className = 'pm-lightbox';
  dialog.setAttribute('aria-label', 'Portfolio image viewer');
  dialog.innerHTML =
    '<img alt="">' +
    '<button type="button" class="pm-lightbox-prev" aria-label="Previous image">&#8249;</button>' +
    '<button type="button" class="pm-lightbox-next" aria-label="Next image">&#8250;</button>' +
    '<button type="button" class="pm-lightbox-close" aria-label="Close">&times;</button>';
  document.body.appendChild(dialog);

  var image = dialog.querySelector('img');
  var current = 0;

  function show(index) {
    current = (index + links.length) % links.length;
    var link = links[current];
    var thumb = link.querySelector('img');
    image.src = link.href;
    image.alt = thumb ? thumb.alt : '';
  }

  links.forEach(function (link, index) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      show(index);
      dialog.showModal();
    });
  });

  dialog.querySelector('.pm-lightbox-prev').addEventListener('click', function () {
    show(current - 1);
  });
  dialog.querySelector('.pm-lightbox-next').addEventListener('click', function () {
    show(current + 1);
  });
  dialog.querySelector('.pm-lightbox-close').addEventListener('click', function () {
    dialog.close();
  });

  // Click on the dark backdrop (the dialog element itself) closes it.
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) dialog.close();
  });

  dialog.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowLeft') show(current - 1);
    if (event.key === 'ArrowRight') show(current + 1);
  });
})();